import type { QueryClient } from "@tanstack/react-query";
import { UNREACHABLE_MESSAGE } from "@/lib/api";
import { authClient } from "@/lib/auth-client";
import { clearAccountQueryData, sessionKey } from "./queries";

/**
 * Starts playing as a guest: a new guest session, then nothing cached from before, so every query
 * asks again as the guest. Whoever calls it goes on to where they were heading.
 */
export async function startGuestSession(queryClient: QueryClient): Promise<void> {
  const { error } = await authClient.signIn.anonymous();
  if (error) throw new Error(error.message?.trim() || UNREACHABLE_MESSAGE);
  clearAccountQueryData(queryClient);
  await queryClient.resetQueries({ queryKey: sessionKey, exact: true });
}
